var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"former-products",attrs:{"id":"home-former-products"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"title headline-l"},[_vm._v(" "+_vm._s(_vm.$t("homeScreen.formerProducts.title"))+" ")]),_c('div',{staticClass:"text text-l"},[_vm._v(" "+_vm._s(_vm.$t("homeScreen.formerProducts.description"))+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }